import React from "react";
import {
  FunctionField,
  Labeled,
  ReferenceField,
  ShowProps,
  TextField,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import TypeField from "../../components/TypeField";
import CustomTypeField from "./components/CustomTypeField";

const Summary = (props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Student</Typography>
        </Grid>

        <Grid item xs={4}>
          <Labeled source="Student">
            <ReferenceField source="studentId" reference="students">
              <FunctionField
                render={(record: any) =>
                  `${record.firstName} ${record.lastName}`
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Change Request Detail</Typography>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Wef Date">
            <CustomDateField source="wefDate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="End Date">
            <CustomDateField source="endDate" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={2}>
          <Labeled source="Type">
            <TypeField source="type" type="changeRequest_FormType" />
          </Labeled>
        </Grid>
        <Grid item xs={2}>
          <Labeled source="Routeplanner Role">
            <TypeField
              source="busScheduleStatus"
              label="Routeplanner Role"
              type="changeRequest_busSchedule"
            />
          </Labeled>
        </Grid>
        <Grid item xs={2}>
          <Labeled source="Cs Role">
            <TypeField
              source="invoiceStatus"
              label="CS Role"
              type="changeRequest_invoice"
            />
          </Labeled>
        </Grid>
        <Grid item xs={2}>
          <Labeled source="Status">
            <TypeField source="status" type="changeRequest_status" />
          </Labeled>
        </Grid>
        <Grid item xs={4}></Grid>

        <Grid item xs={4}>
          <Labeled source="Description">
            <TextField source="description" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <Labeled source="Cs Description">
            <TextField source="csDescription" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
